import { EngineUtils } from '../services/EngineUtils.js';
export class ObjectHashSetWithPayload {
    constructor(aggregateFunction) {
        this.aggregateFunction = aggregateFunction;
        this.referenceSet = new Map();
    }
    add(value, payload) {
        let payloadToSave = payload;
        const hash = EngineUtils.hash(value);
        if (this.referenceSet.has(hash)) {
            const [, prevPayload] = this.referenceSet.get(hash);
            payloadToSave = this.aggregateFunction(prevPayload, payload);
        }
        this.referenceSet.set(hash, [value, payloadToSave]);
    }
    has(value) {
        return this.referenceSet.has(EngineUtils.hash(value));
    }
    delete(value) {
        this.referenceSet.delete(EngineUtils.hash(value));
    }
    toArray() {
        return Array.from(this.referenceSet.values());
    }
}
export function keepLastAggregateFunction(prev, next) {
    return next;
}
export function keepFirstAggregateFunction(prev, next) {
    return prev;
}
//# sourceMappingURL=ObjectHashSetWithPayload.js.map